import { combineReducers } from 'redux';

import callout from './common/callout';
import map from './common/map';
import map3d from './common/map3d';
import robot from './common/robot';
import robots from './common/robots';
import robotStatus from './common/robotStatus';
import telemetry from './common/telemetry';
import user from './common/user';
import command from './control-center/command';
import missionsForControlCenter from './control-center/missions';
import notifications from './control-center/notifications';
import robotOptions from './control-center/robotOptions';
import robotParams from './control-center/robotParams';
import query from './flight-review/query';
import editor from './mission-hub/editor';
import mission from './mission-hub/mission';
import missionsForMissionHub from './mission-hub/missions';
import videos from './video-manager/videos';

export const getReducerForPage = (pageType) => {
  const reducers = {};

  switch (pageType) {
    case 'control-center':
      reducers.callout = callout;
      reducers.command = command;
      reducers.map = map;
      reducers.map3d = map3d;
      reducers.missions = missionsForControlCenter;
      reducers.notifications = notifications;
      reducers.robot = robot;
      reducers.robots = robots;
      reducers.robotOptions = robotOptions;
      reducers.robotParams = robotParams;
      reducers.robotStatus = robotStatus;
      reducers.telemetry = telemetry;
      reducers.user = user;
      break;

    case 'mission-hub':
      reducers.callout = callout;
      reducers.editor = editor;
      reducers.map = map;
      reducers.map3d = map3d;
      reducers.mission = mission;
      reducers.missions = missionsForMissionHub;
      reducers.robots = robots;
      reducers.robotStatus = robotStatus;
      reducers.telemetry = telemetry;
      reducers.user = user;
      break;

    case 'mobile':
      reducers.map = map;
      reducers.robot = robot;
      reducers.robots = robots;
      reducers.telemetry = telemetry;
      reducers.user = user;
      break;

    case 'video-manager':
      reducers.robot = robot;
      reducers.robots = robots;
      reducers.user = user;
      reducers.videos = videos;
      break;

    case 'flight-review':
      reducers.robots = robots;
      reducers.user = user;
      reducers.query = query;
      break;

    default:
      break;
  }

  // Reducer 없는 경우 (e.g. /login)
  if (Object.keys(reducers).length === 0) {
    return (state = {}) => state;
  }
  return combineReducers(reducers);
};
